import { IconName, NonIdealState as BpNonIdealState } from "@blueprintjs/core";
import styled from 'styled-components';

const Cont = styled.div`
	margin: 20px;
`;

interface INonIdealStateProps {
	children?: never;
	icon?: IconName;
	title: React.ReactNode;
	description: React.ReactChild;
	action?: JSX.Element;
}

const NonIdealState: React.SFC<INonIdealStateProps> = ({
	title, description, action
}) => (
	<Cont>
		<BpNonIdealState
			title={title}
			description={description}
			action={action}
		/>
	</Cont>
);

export default NonIdealState;



// WEBPACK FOOTER //
// ./src/common/fragments/NonIdealState.tsx